import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "splash-container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "text-white" }, "Confirm E-mail Address / Username Update", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "text-white" }, "You must confirm the request to update your e-mail. Once you confirm, you will be redirected to the SAMS login page, from which you must login using the new e-mail address. You may also click 'Cancel' to continue using the old e-mail address.", -1)
const _hoisted_4 = { class: "form-group" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", {
  for: "current",
  class: "form-label text-white"
}, "Current Email Address / Username", -1)
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", {
  for: "new",
  class: "form-label text-white"
}, "New Email Address / Username", -1)
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "d-flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("form", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("input", {
        type: "email",
        class: "form-control",
        readonly: "",
        value: _ctx.emails.current
      }, null, 8, _hoisted_6)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      _createElementVNode("input", {
        type: "email",
        readonly: "",
        class: "form-control",
        value: _ctx.emails.updated
      }, null, 8, _hoisted_9)
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("button", {
        class: "btn btn-warning me-auto",
        type: "button",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args)))
      }, "Cancel"),
      _createElementVNode("button", {
        class: "btn btn-primary ms-auto",
        type: "button",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.confirm && _ctx.confirm(...args)))
      }, "Confirm")
    ])
  ]))
}